import React from 'react'
import Footer from '../components/Footer'

function Tap() {
  return (
    <div className='flex flex-col'>
        <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg'>Tap</h1>
      </div>
      <div className='h-[600px] w-full grow flex flex-col justify-center items-center'>
         <h2 className='font-bold '>NFT Enabled</h2>
         <button className='my-[24px] px-5 py-3 bg-black text-white rounded-3xl font-bold'>Tap to connect</button>
         <p className='text-gray-500 text-sm'>Tap to Connect with Someone</p>
      </div>
      <Footer active={'Tap'}/>
    </div>
  )
}

export default Tap